// @NOTE: assumes jQuery is included by WP
const $ = jQuery
import Swiper from 'swiper';

class header {
  constructor () {
    this.$siteHeader           = $('.header')
    this.$mobileNavButton      = $(".mobile-btn") 
    this.$closeMobileButton    = $(".close-mobile-nav")
    this.$mobileNavBg          = $(".mobile-nav-bg-curtain")
    this.$arrow                = $('.arrow') 

    
    this.initSwiperSlider()
    this.goToSection () 
    //this.anchorClick()

    this.$mobileNavButton.click(function () { 
      $(".navigation").addClass('menu-open')
      $(".mobile-nav-bg-curtain").addClass('menu-open')
    }); 

    this.$closeMobileButton.click(function () { 
      $(".navigation").removeClass('menu-open') 
      $(".mobile-nav-bg-curtain").removeClass('menu-open')
    }); 

    this.$mobileNavBg.click(function () { 
      $(".navigation").removeClass('menu-open') 
      $(".mobile-nav-bg-curtain").removeClass('menu-open')
    });

    this.$arrow.on('click', (event) => {
      $(event.currentTarget).next('.sub-menu').toggleClass('show');
    }) 


    $('a').click((event) => { 
			const $clickedLink = $(event.currentTarget)
			const attr = $clickedLink.attr('href')
      let eventName = ''

      if (this.isExternal(attr)) {
        eventName = 'outbound'
      } else if (this.isInternalFileUrl(attr)) {
        eventName = 'internal'
      } else {
        return
      }
			
			ga('send', 'event', eventName, 'click', attr, {
        'transport': 'beacon',
        'hitCallback': function(){document.location = attr;}
      });
		})
  }

  isExternal (url) {
    var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
    if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
    if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":("+{"http:":80,"https:":443}[location.protocol]+")?$"), "") !== location.host) return true;
    return false;
  }

  isInternalFileUrl (url) {
    const internalFileURLPrefix = window.location.origin + '/wp-content/uploads'
    return url.includes(internalFileURLPrefix)
  }

  goToSection () {
    $("a.js-cta-link-category").on('click', function(event) {

      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();
  
        // Store hash
        var hash = this.hash;
  
        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 800, function(){
  
          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = hash;
        });
      } // End if
    });
  }


  onWindowScroll (scrollTop) {   
    if (scrollTop >= 60) {
      this.$siteHeader.addClass('js-fixed-header')
    } else {
      this.$siteHeader.removeClass('js-fixed-header')
    } 
  }

  initSwiperSlider () { 
    var textSwiper = new Swiper('.event-carousel', {
		  // Optional parameters  
		  slidesPerView: 1, 
		  loop: true, 
      spaceBetween: 20,
      //fadeEffect: { crossFade: true },
      autoplay: {
        delay: 7000,
        disableOnInteraction: true,
      }, 
      //effect: "fade",
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
		  // Navigation arrows
		  navigation: {
		    nextEl: '.swiper-button-next',
		    prevEl: '.swiper-button-prev',
		  },
      breakpoints: { 
        300: {
          slidesPerView: 1, 
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 1, 
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2, 
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3, 
          spaceBetween: 30,
        },
        1400: {
          slidesPerView: 4, 
          spaceBetween: 75,
        },
      },
		})


    var textSwiper = new Swiper('.knowledge-center-carousel', {
		  // Optional parameters  
		  slidesPerView: 1, 
		  loop: true, 
      spaceBetween: 20,
      //fadeEffect: { crossFade: true },
      autoplay: {
        delay: 7000,
        disableOnInteraction: true,
      }, 
      //effect: "fade",
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
		  // Navigation arrows
		  navigation: {
		    nextEl: '.swiper-button-next',
		    prevEl: '.swiper-button-prev',
		  },
      breakpoints: {
        640: {
          slidesPerView: 1, 
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2, 
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 2, 
          spaceBetween: 30,
        },
        1400: {
          slidesPerView: 3, 
          spaceBetween: 75,
        },
      },
		})
  }

  // anchorClick () {
  //   $('a').click((event) => {
  //     event.preventDefault()
  //     const $currentInput = $(event.currentTarget)
      
  //     const anchorUrl = $currentInput.attr('href');
  //     this.captureOutboundLink(anchorUrl) 
	// 	})
  // }

  // captureOutboundLink(url) {
     
  //   ga('send', 'event', 'outbound', 'click', url, {
  //     'transport': 'beacon',
  //     'hitCallback': function(){document.location = url;}
  //   });
  // }

}

export default header


// WEBPACK FOOTER //
// ./src/js/custom/header/header.js